import store from "../store/store";
import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '../views/Dashboard.vue'
import Login from "../views/Login.vue";
import Register from "../views/Register";
import Jurnal from "../views/Jurnal";
import ProjectDashboard from "../views/ProjectDashboard";
import IncomeStatement from "../views/IncomeStatement";
// import Account from "../views/Account";
// import TransactionCategory from "../views/TransactionCategory";
import Project from "../views/Project";
import BalanceSheet from "@/views/BalanceSheet";

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: 'dashboard',
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: {
      title: 'Dashoard',
      requiresAuth: true
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/register',
    name: 'register',
    component: Register
  },
  {
    path: '/cashflow',
    name: 'cashflow',
    component: Jurnal,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/projects',
    name: 'projects-dashboard',
    component: ProjectDashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/projects/:id',
    name: 'projects',
    component: Project,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/income-statement',
    name: 'income-statement',
    component: IncomeStatement,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/balance-sheet',
    name: 'balance-sheet',
    component: BalanceSheet,
    meta: {
      requiresAuth: true
    }
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  var user = JSON.parse(localStorage.getItem('user')) || null;

  if (user && !store.getters.isAuthenticated) {
    var lastLogin = new Date(JSON.parse(localStorage.getItem('user-logged')));
    var now = new Date();
    var diff = (lastLogin.getTime() - now.getTime()) / 1000;
    diff /= (60 * 60);
    diff = Math.abs(Math.round(diff));

    if (diff >= 24 * 7) {
      localStorage.removeItem('user');
      localStorage.removeItem('user-logged');
      user = null;
    }

    store.commit('SET_USER', user);
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters.isAuthenticated) {
      next({ name: 'login' })
    } else {
      next() // go to wherever I'm going
    }
  }

  next();
});

const DEFAULT_TITLE = 'Terran';
router.afterEach((to) => {
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE;
  });
});

export default router
